// extracted by mini-css-extract-plugin
module.exports = {"container":"Profile_container__7b9im","heading":"Profile_heading__1iTYJ","caption":"Profile_caption__1RlK9"};